import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { registerComponents } from "@/components";
import "./style.css";
import { instance, axios } from "./services/axios";
import "./plugins/fontawesome";
import mitt from "mitt";
import vueDebounce from "vue-debounce";
import VueNumerals from "vue-numerals";
import VueCookies from "vue-cookies";
import liff from "@line/liff";
import swal from "sweetalert";
import DatetimePicker from "vuetify-datetime-picker";
import moment from "moment";
import VueClipboard from "vue-clipboard2";
import QrcodeVue from "qrcode.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";

const emitter = mitt();

const app = createApp({
  extends: App
});
app.component("VueDatePicker", VueDatePicker);
app.component("QrcodeVue", QrcodeVue);
app

  .use(VueClipboard)
  .use(vueDebounce)
  .use({
    install(Vue) {
      app.config.globalProperties.$swal = swal;
    }
  })
  .use(VueCookies)
  .use(DatetimePicker)
  .use(VueNumerals);

VueClipboard.config.autoSetContainer = true; // add this line
app.config.globalProperties.$apiKey = "ChAtA7Ds40p";
app.config.globalProperties.$formatDate = "DD MMM YYYY";
app.config.globalProperties.$formatDateTime = "DD MMM YYYY HH:mm";
if (window.Cypress) {
  app.config.globalProperties.$liff = window.Cypress.liffMock;
} else {
  app.config.globalProperties.$liff = liff;
}
app.config.globalProperties.$liffUrl = process.env.VUE_APP_LIFF_URL;
app.config.globalProperties.handleImageSrc = require("@/assets/images/default-image.png");

app.config.globalProperties.$store = store;
app.config.globalProperties.$router = router;
app.config.globalProperties.$axios = instance;
app.config.globalProperties.axios = axios;
app.config.globalProperties.emitter = emitter;

app.config.globalProperties.moment = date => moment(date);


const originalFetch = window.fetch;
function customFetch(url, options) {
  if (
    url.toString().startsWith("https://liffsdk.line-scdn.net/xlt/") &&
    url.toString().endsWith(".json")
  ) {
    url = url + "?ts=" + Math.random();
  }
  return originalFetch(url, options);
}
window.fetch = customFetch;

async function initializeApp() {
  let location = window.location.hostname;
  let liffId = process.env.VUE_APP_LIFF_URL.replace("https://liff.line.me/", "");
  var liffMock = liff;

  if (window.Cypress) {
    liffId = window.Cypress.liffMock.liffId;
    liffMock = window.Cypress.liffMock;
    app.config.globalProperties.$liffId = window.Cypress.liffMock.liffId;
  } else {
    app.config.globalProperties.$liffId = liffId;
  }

  genarateFont();
  app.config.globalProperties.$lineLayout = "Minimal";


  registerComponents(app, 'Minimal');
  
  loadTheme("vuetifyNewTheme");
  loadTheme("buttonNewTheme");

  const vuetify = createVuetify({
    theme: {
      defaultTheme: "customTheme",
      themes: {
        customTheme: {
          colors: {
            surface: "#FFFFFF"
          },
          variables: {
            "medium-emphasis-opacity": "1 !important"
          }
        }
      }
    },
    components,
    directives,
    icons: {
      defaultSet: "mdi",
      aliases,
      sets: {
        mdi
      }
    }
  });

  liffMock.init({ liffId: liffId }).then(() => {
    app.use(router).use(store).use(vuetify).mount("#app");
  });
  
  //app.use(router).use(store).use(vuetify).mount("#app");
}

function genarateFont() {
  const fontBold = "/font/Kanit-SemiBold.ttf";
  const fontRegular = "/font/Kanit-Regular.ttf";
  var newStyle = document.createElement("style");

  const fontFaceRule = `
        @font-face {
            font-family: 'CustomFont';
            src: url('${fontRegular}') format('truetype');
            font-weight: 400;
            font-display: swap;
        }
    `;

  const fontFaceRuleBold = `
        @font-face {
            font-family: 'CustomFont';
            src: url(${fontBold}) format('truetype');
            font-weight: 600;
            font-display: swap;
        }
    `;
  newStyle.appendChild(
    document.createTextNode(fontFaceRule + fontFaceRuleBold)
  );

  document.head.appendChild(newStyle);
}

function loadTheme(themeName) {
  const existingLink = document.getElementById(`theme-style-${themeName}`);
  if (existingLink) existingLink.remove();

  const link = document.createElement("link");
  link.id = `theme-style-${themeName}`;
  link.rel = "stylesheet";

  link.href = `/stylesheets/custom/${themeName}.css`;

  document.head.appendChild(link);
}

initializeApp();

export { liff };
